<template>
  <symbol
    id="pin-spot"
    viewBox="0 0 53.45 60.49"
  >
    <path d="M53.45,26.72A26.73,26.73,0,0,0,27,0,27,27,0,0,0,0,26.53a26.73,26.73,0,0,0,17.28,25.2,13.5,13.5,0,0,1,5.13,3.5,55.3,55.3,0,0,1,3.85,5,.62.62,0,0,0,1,0c1.5-1.79,3-3.84,4.61-5.47a13.75,13.75,0,0,1,4.77-3.24A26.74,26.74,0,0,0,53.45,26.72Z" />
    <circle
      cx="26.61"
      cy="26.58"
      r="14.71"
      stroke="#fff"
      stroke-miterlimit="10"
      stroke-width="8.5"
    />
  </symbol>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// default.vue?54b40ba3